module.exports = __webpack_public_path__ + "img/bleu-2.b3d008e2.png";